import React from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { string, bool } = proptypes;

export const MoreOptions = ({ canonicalUrl, displayInTooltip = false }) => {
  const baseClasses = 'sui-w-auto sui-sticky sui-flex sui-items-center sui-flex-col sui-py-2';
  const tooltipClasses = 'sui-h-12 sui-pt-4 sui-bg-white sui-border-t sui-border-gray-200';
  const classes = displayInTooltip ? `${baseClasses} ${tooltipClasses}` : baseClasses;

  return (
    <div className={classes}>
      <Link
        href={canonicalUrl}
        target="_blank"
        rel="noopener noreferrer"
        color="subtle"
        underline="none"
      >
        More Options
      </Link>
    </div>
  );
};

MoreOptions.displayName = 'MoreOptions';

MoreOptions.propTypes = {
  canonicalUrl: string.isRequired,
  displayInTooltip: bool
};
